import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '@/store';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('../pages/home'),
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('../pages/about'),
    meta: {
      hasFooter: true,
    },
  },
  {
    path: '/about/detail/:id',
  },
  {
    path: '/news',
    name: 'news',
    component: () => import('../pages/news/list'),
  },
  {
    path: '/news/:name/:id',
    name: 'news-detail',
    component: () => import('../pages/news/detail'),
    props: true,
  },
  {
    path: '/awards',
    name: 'awards',
    component: () => import('../pages/award'),
  },
  {
    path: '/contact',
    name: 'contact',
    component: () => import('../pages/contact'),
  },
  {
    path: '/products',
    name: 'projects',
    component: () => import('../pages/product/list'),
    redirect: '/products/img',
    children: [
      {
        path: 'row/:name?/:type?',
        name: 'project-list-type-row',
        component: () => import('../pages/product/_row'),
      },
      {
        path: 'img/:name?/:type?',
        name: 'project-list-type-img',
        component: () => import('../pages/product/_img'),
      },
    ],
  },
  {
    path: '/product/:name/:id',
    name: 'product-detail',
    component: () => import('../pages/product/detail'),
    props: true,
  },
  {
    path: '/join',
    name: 'join',
    component: () => import('../pages/join'),
  },
  {
    path: '/test',
    name: 'test',
    component: () => import('../pages/test.vue'),
  },
];

const router = new VueRouter({
  mode: process.env.NODE_ENV === 'development' ? 'hash' : 'history',
  // mode: process.env.NODE_ENV === 'development' ? 'hash' : 'hash',
  base: process.env.NODE_ENV === 'development' ? '/demo1' : process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return {
      x: 0,
      y: 0,
    };
  },
});

router.beforeEach((to, from, next) => {
  const toName = to.params.name ? to.params.name : to.name;
  store.commit('SET_ENTER_ROUTER', toName);
  store.commit('CLOSE_MENU');
  if (store.state.firstEnterWebSite) {
    next();
  } else {
    setTimeout(() => {
      next();
    }, 1200);
  }
});

router.afterEach(() => {
  store.commit('SET_ENTER_ROUTER', null);
});
export default router;
